var _circle, _circle2, _circle3, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line0, _line1, _line10, _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFeatureIcon2 = function SvgFeatureIcon2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 120,
    viewBox: "0 0 116 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6012,
    cy: 62.4,
    r: 57.6,
    fill: "#E38BB6"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6,
    cy: 60,
    r: 57.6,
    fill: "black"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 57.6008,
    cy: 57.6,
    r: 56.6,
    stroke: "#65C9DB",
    strokeWidth: 2,
    strokeDasharray: "5 5"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 49.9069,
    y1: 35.7,
    x2: 49.9069,
    y2: 31.5,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 57.1068,
    y1: 35.7,
    x2: 57.1068,
    y2: 31.5,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 64.3068,
    y1: 35.7,
    x2: 64.3068,
    y2: 31.5,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 81.7068,
    y1: 51.3003,
    x2: 85.9068,
    y2: 51.3003,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 81.7068,
    y1: 58.5002,
    x2: 85.9068,
    y2: 58.5002,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 81.7068,
    y1: 65.7002,
    x2: 85.9068,
    y2: 65.7002,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 49.9069,
    y1: 88.5002,
    x2: 49.9069,
    y2: 84.3002,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 57.1068,
    y1: 88.5002,
    x2: 57.1068,
    y2: 84.3002,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 64.3068,
    y1: 88.5002,
    x2: 64.3068,
    y2: 84.3002,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line0 || (_line0 = /*#__PURE__*/React.createElement("line", {
    x1: 28.9066,
    y1: 51.3003,
    x2: 33.1066,
    y2: 51.3003,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line1 || (_line1 = /*#__PURE__*/React.createElement("line", {
    x1: 28.9066,
    y1: 58.5002,
    x2: 33.1066,
    y2: 58.5002,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 28.9066,
    y1: 65.7002,
    x2: 33.1066,
    y2: 65.7002,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 34.6068,
    y: 37.2,
    width: 45.6,
    height: 45.6,
    rx: 8,
    stroke: "#65C9DB",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.6068 68.4L53.8068 50.4L61.0068 68.4M65.8068 68.4V57M65.8068 51V50.4M58.1268 62.4H53.8068H49.4868",
    stroke: "#E7F58D",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgFeatureIcon2;